const Dining = ({ dining, currency, styles, formatPriceWithCurrency }) => {

  return (dining.dinning_options.length > 0) && (
    <div className={styles.cartItem} id="dining-info">
      <h3>Dining</h3>
      <div className={styles.cro1381HotelMeta}>
        {dining.dinning_options.map((dining1) => {
          return (
            <p className={styles.productInfo}>
              <p
                className={styles.product + " " + styles.ticketDesc}
                data-testId="dining-title"
              >
                {dining1.title}
              </p>
              <p
                className={styles.product + " " + styles.ticketDesc}
                data-testId="dining-booked-for"
              >
                {`${dining1.booked_for.adult} x Adult${
                  dining1.booked_for.child > 0
                    ? `, ${dining1.booked_for.child} x Child`
                    : ""
                }`}
              </p>
            </p>
          );
        })}
        <p className={styles.diningTotal}>
          <span className={styles.price} data-testId="dining-total">
            {formatPriceWithCurrency(dining.total_dining_price)}
          </span>
        </p>
      </div>
    </div>
  );
};
export default Dining;
